import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { openAttachmentPreview } from '@simOn/common/attachment-preview';
import { MediaApiService } from '@simOn/common/media';
import { DocumentsApiService } from '@simOn/documents/element/data-access';
import { firstValueFrom } from 'rxjs';
import { OpenDocumentActionDto } from '../model';

/**
 * Handles the `OpenDocument` action: the card carries ids only, so the document is fetched through the
 * existing document flow and shown in the attachment preview, or the documents page opens inside the
 * folder when the id points at a directory.
 */
@Injectable({ providedIn: 'root' })
export class AgentDocumentService {
  private readonly _documentsApi = inject(DocumentsApiService);
  private readonly _mediaApi = inject(MediaApiService);
  private readonly _dialog = inject(Dialog);
  private readonly _router = inject(Router);

  async open(action: OpenDocumentActionDto): Promise<void> {
    const document = await firstValueFrom(this._documentsApi.getDocument(action.documentId));

    if (document.isDirectory) {
      await this._router.navigate(['/space', action.apartmentId, 'documents'], {
        queryParams: { folderId: document.id }
      });
      return;
    }

    const url = document.url;
    if (!url) throw new Error(`[ai-agent] document "${action.documentId}" has no file to open`);
    openAttachmentPreview(this._dialog, {
      name: document.name ?? action.fileName ?? '',
      fileId: document.id,
      source: () => this._mediaApi.generateBlobUrlForDownload(url),
      hasDownloadAction: true
    });
  }
}
